import { render } from "./HmenuItem.vue?vue&type=template&id=a36c03c4"
import script from "./HmenuItem.vue?vue&type=script&lang=js"
export * from "./HmenuItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__